import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class FileFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
    } = this.props;

    return (
      <div className="filters-container admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Type:</label>
            <Select name="type" options={enums.fileTypes} selectLabel="-" emptyOption/>
          </FormGroup>
          {/*<FormGroup>
            <label>Name:</label>
            <Input name="name" type="text"/>
          </FormGroup>*/}
        </Form>
      </div>
    );
  }
}

export default FileFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/FileFilters/FileFilters.view.js